namespace GeniuzPOS.Lookups {
    export namespace VwDashboardPageService {
        export const baseUrl = 'Lookups/VwDashboardPage';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwDashboardPageRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwDashboardPageRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwDashboardPage/Retrieve",
            List = "Lookups/VwDashboardPage/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwDashboardPageService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
